var render, staticRenderFns
import script from "./ThgImpactSelectorOnlyCustomerAccountAndPayout.vue?vue&type=script&lang=ts"
export * from "./ThgImpactSelectorOnlyCustomerAccountAndPayout.vue?vue&type=script&lang=ts"
import style0 from "./ThgImpactSelectorOnlyCustomerAccountAndPayout.vue?vue&type=style&index=0&id=af946fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af946fdc",
  null
  
)

export default component.exports